var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 9C4.5 9.16576 4.56585 9.32473 4.68306 9.44194C4.80027 9.55915 4.95924 9.625 5.125 9.625H12.3663L9.6825 12.3075C9.56514 12.4249 9.49921 12.584 9.49921 12.75C9.49921 12.916 9.56514 13.0751 9.6825 13.1925C9.79986 13.3099 9.95903 13.3758 10.125 13.3758C10.291 13.3758 10.4501 13.3099 10.5675 13.1925L14.3175 9.4425C14.3757 9.38444 14.4219 9.31547 14.4534 9.23954C14.4849 9.16361 14.5011 9.08221 14.5011 9C14.5011 8.91779 14.4849 8.83639 14.4534 8.76046C14.4219 8.68453 14.3757 8.61556 14.3175 8.5575L10.5675 4.8075C10.4501 4.69014 10.291 4.62421 10.125 4.62421C9.95903 4.62421 9.79986 4.69014 9.6825 4.8075C9.56514 4.92486 9.49921 5.08403 9.49921 5.25C9.49921 5.41597 9.56514 5.57514 9.6825 5.6925L12.3663 8.375H5.125C4.95924 8.375 4.80027 8.44085 4.68306 8.55806C4.56585 8.67527 4.5 8.83424 4.5 9ZM1.375 17.75C1.20924 17.75 1.05027 17.6842 0.933058 17.5669C0.815848 17.4497 0.75 17.2908 0.75 17.125V0.875C0.75 0.70924 0.815848 0.550268 0.933058 0.433058C1.05027 0.315848 1.20924 0.25 1.375 0.25C1.54076 0.25 1.69973 0.315848 1.81694 0.433058C1.93415 0.550268 2 0.70924 2 0.875V17.125C2 17.2908 1.93415 17.4497 1.81694 17.5669C1.69973 17.6842 1.54076 17.75 1.375 17.75Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f268231e3335e0523a08fcac816a537f.svg";
export { ForwardRef as ReactComponent };